export default __webpack_public_path__ + "static/media/getboatcom_for_boat_owners.0c4b9470.webp";